import { ENABLE_RETAILER_SHIPPING_PREFERENCE_PAGE_230908 } from "@faire/web-api/indigofair/settings/ENABLE_RETAILER_SHIPPING_PREFERENCE_PAGE_230908";

import { useSetting } from "./__internal__/useSetting";

export const useSettingEnableRetailerShippingPreferencePage = (): boolean =>
  useSetting(ENABLE_RETAILER_SHIPPING_PREFERENCE_PAGE_230908, false);
